export default "__VITE_ASSET__CGCi65fC__"